export const buildDirectorySearchQuery = (data: {
  acc_coname?: string;
  acc_country?: string;
  category?: string;
}): string => {
  const params = new URLSearchParams();
  for (const key of ['acc_coname', 'acc_country', 'category'] as const) {
    if (data[key]) params.set(key, data[key]!);
  }
  const query = params.toString();
  return query ? `&${query}` : '';
};
